var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex"},_vm._l((_vm.options),function(option,index){return _c('div',{key:option.value},[_c('button',{ref:option.value + 'button',refInFor:true,class:[
        _vm.paddingClass,
        _vm.fontSizeClass,
        _vm.leadingClass,
        _vm.colorClass,
        _vm.selectedClass(option.value),
        _vm.borderClass(index),
        'tw-shadow-none tw-font-sans tw-inline-flex tw-items-center tw-justify-center tw-transition tw-ease-in-out tw-duration-100 tw-relative',
      ],attrs:{"type":"button"},on:{"click":function($event){return _vm.handleClick(option.value)}}},[_vm._v("\n      "+_vm._s(option.label)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }